<template>
  <div>
    <h4>Tags</h4>
    <div class="card p-3 relative">
      <b-spinner v-if="inProgress" small style="position: absolute; right: 15px; top: 15px;"></b-spinner>
      <Multiselect
          class="mt-4"
          v-model="value"
          :options="options"
          :searchable="true"
          :allow-empty="true"
          :multiple="true"
          :taggable="allowNewTags || options.length === 0"
          :placeholder="`Tags ${ options.length === 0 ? 'hinzufügen' : (allowNewTags ? 'suchen, hinzufügen' : 'suchen') + ' und auswählen'}`"
          selectedLabel="Ausgewählt"
          deselectLabel="Klick oder Enter zum entfernen"
          selectLabel="Klick oder Enter zum auswählen"
          @input="hasChanged"
          @tag="addTag"
          tagPlaceholder="Klick oder Enter zum hinzufügen"
      >
        <span slot="noResult">Keine Ergebnisse gefunden.</span>
        <span slot="noOptions">Bitte Tag eingeben und mit Enter hinzufügen.</span>
      </Multiselect>
      <label class="pt-2 mb-0" v-if="tagsNote" v-html="tagsNote"></label>
    </div>
  </div>
</template>


<script>
import platformSettings from '~config/settings'
import { Multiselect } from 'vue-multiselect'
import products from "@/api/products";

export default {
  inject: ['showSuccessAlert'],
  name: 'ProductTags',
  components: {
      Multiselect
  },
  data(){
    return {
      inProgress: false,
      value: [],
      options: platformSettings.productTags || [],
      allowNewTags: platformSettings.productTagsAllowCustom || false,
      tagsNote: platformSettings.productTagsNote || false
    }
  },
  created() {
    this.value = this.tags
  },
  computed: {
    productId () {
      return this.$route.params.id
    },
    tags: {
      get () {
        return this.$store.state.products.product.tags || []
      }
    }
  },
    methods: {
      async hasChanged() {
          this.inProgress = true
          await products.put(this.productId, {tags: this.value}).finally(() => {
              this.inProgress = false
          })
          this.$store.commit('products/setTags', {tags: this.value})
      },
        addTag (newTag) {
          if (!this.allowNewTags && this.options.length !== 0) return
            this.value.push(newTag)
            if (platformSettings.productTags) {
                this.options.push(newTag)
            } else {
                this.hasChanged()
            }
        }
    }
}
</script>
